import { IProjectState } from "../../../shared/interfaces/IOrganizationState";

export const InitialState:IProjectState={
    projectData:[],
    isProjectPopUpOpen:false
}